import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment?.production) {
    enableProdMode();
} else {
    //document.write('<h1> Estamos en QA </h1>');
    //document.write(environment.url);
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
